import { useState } from 'react';
import './Result.scss';
import { formatNumber } from '../../utils/numbers';

function CopyButton({ text }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    if (!text && text !== 0) return;
    try {
      if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(String(text));
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      }
    } catch (err) {
      console.error('Kopiointi epäonnistui:', err);
    }
  };

  return (
    <button
      type="button"
      className={`copy-button ${copied ? 'copied' : ''}`}
      onClick={handleCopy}
      title="Kopioi leikepöydälle"
      aria-label="Kopioi leikepöydälle"
    >
      {copied ? 'Kopioitu!' : 'Kopioi'}
    </button>
  );
}

function Result({ tax, taxPrice, taxlessPrice, taxes }) {
  const formattedTax = formatNumber(tax);
  const formattedTaxPrice = formatNumber(taxPrice);
  const formattedTaxlessPrice = formatNumber(taxlessPrice);
  const formattedTaxes = formatNumber(taxes);

  return (
    <dl className="calculator-result">
      <dt>Vero %</dt>
      <dd>
        <span>{formattedTax}%</span>
        <CopyButton text={`${formattedTax}%`} />
      </dd>

      <dt>Verollinen hinta</dt>
      <dd>
        <span>{formattedTaxPrice}</span>
        <CopyButton text={formattedTaxPrice} />
      </dd>

      <dt>Veroton hinta</dt>
      <dd>
        <span>{formattedTaxlessPrice}</span>
        <CopyButton text={formattedTaxlessPrice} />
      </dd>

      <dt>Veron määrä</dt>
      <dd>
        <span>{formattedTaxes}</span>
        <CopyButton text={formattedTaxes} />
      </dd>
    </dl>
  );
}

export default Result;
